export const allVehicleVariants = ['unknown', 'ican', 'fms1', 'fms2', 'fms3', 'fms4', 'nhmr', 'tgx', 'vw', 'e4c'];
